import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fCurrency(number) {
  return numeral(number).format(Number.isInteger(number) ? '$0,0' : '$0,0.00');
}
export function fRial(number) {
  return numeral(number).format(Number.isInteger(number) ? '$0,0' : '$0,0.00');
} 

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return numeral(number).format('0.00a').replace('.00', '');
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}

export function fCardNum(number) {
  try{
    const v = number
        .replace(/\s+/g, "")
        .replace(/[^0-9]/gi, "")
        .substr(0, 16);
    const parts = [];

    for (let i = 0; i < v.length; i += 4) {
      parts.push(v.substr(i, 4));
    }

    return parts.length > 1 ? parts.join("-") : number;
  }catch (e) {
    return ''
  }
}

export function fCardSheba(number) {
  const v = number
    // .replace(/\s+/g, "")
    // .replace(/[^0-9]/gi, "")
    // .substr(0, 25);
  const parts = [];

  for (let i = 0; i < v.length; i += 4) {
    parts.push(v.substr(i, 4));
  }

  return parts.length > 1 ? parts.join("   ") : number;
  // return numeral(number).format('xxxx xxxx xxxx xxxx');
}

export const toEnglishNumber = (value) => {
  if (!value) return ""
  const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g]
  const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]

  if (typeof value === 'string') {
    for (let i = 0; i < 10; i++) {
      value = value.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
  }
  return value;
}

export const numberWithCommas = (x) => {
  try {
    let new_x = String(x);
    if (new_x !== 'null' && new_x !== 'undefined') {
      new_x = new_x.split('.')
      let new_x_coma = new_x[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return `${new_x_coma}${typeof new_x[1] !== 'undefined' ? `.${new_x[1]}` : ''}`
    } else {
      return '';
    }
  } catch (e) {
    return '';
  }
}
